export const setFocusInput = (ref) => ref.current.focus();
